import React from "react";
import { MuiTelInput, matchIsValidTel } from "mui-tel-input";

const PhoneField = ({
  id,
  label,
  value,
  onChange,
  margin = "dense",
  error,
  helperText
}) => {
  const handleChange = (newValue) => {
    // Crée un objet event-like pour compatibilité avec handleContactChange
    const syntheticEvent = {
      target: {
        id: id,
        value: newValue
      }
    };
    onChange(syntheticEvent);
  };

  return (
    <MuiTelInput
      fullWidth
      id={id}
      label={label}
      value={value || ""}
      onChange={handleChange}
      defaultCountry="FR"
      variant="outlined"
      margin={margin}
      error={error}
      helperText={helperText}
      InputLabelProps={{
        shrink: true,
        sx: { marginLeft: '40px' }
      }}
      sx={{
        '& .MuiInputLabel-shrink': {
          marginLeft: '0px'
        }
      }}
    />
  );
};

// Fonction utilitaire pour valider un numéro de téléphone
export const isValidPhoneNumber = (phoneNumber) => {
  if (!phoneNumber || phoneNumber.trim() === "") return true; // Champ vide = valide (pas requis)
  return matchIsValidTel(phoneNumber);
};

export default PhoneField;
